import React from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
  Grid,
} from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import TranslateIcon from "@mui/icons-material/Translate";
import { useTranslation } from "react-i18next";

interface TextInputTabProps {
  inputPrompt: string;
  setInputPrompt: (value: string) => void;
  enhanceLoading: boolean;
  translateLoading: boolean;
  isAnyLoading: boolean;
  showTranslate: boolean;
  onEnhance: () => void;
  onTranslate: () => void;
}

const TextInputTab: React.FC<TextInputTabProps> = ({
  inputPrompt,
  setInputPrompt,
  enhanceLoading,
  translateLoading,
  isAnyLoading,
  showTranslate,
  onEnhance,
  onTranslate,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Text Input Section */}
      <Grid size={{ xs: 12 }}>
        <Typography variant="subtitle2" gutterBottom>
          {t("juno.enhancement.input.label")}
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          value={inputPrompt}
          onChange={(e) => setInputPrompt(e.target.value)}
          placeholder={t("juno.enhancement.input.placeholder")}
          variant="outlined"
        />
      </Grid>

      {/* Text Action Buttons */}
      <Grid size={{ xs: 12 }}>
        <Box display="flex" gap={2} justifyContent="space-between" alignItems="center">
          <Typography variant="caption" color="warning">
            {t("juno.enhancement.creditNotice")}
          </Typography>
          <Box display="flex" gap={2}>
            {showTranslate && (
              <Button
                variant="outlined"
                startIcon={
                  translateLoading ? <CircularProgress size={16} color="inherit" /> : <TranslateIcon />
                }
                onClick={onTranslate}
                disabled={
                  isAnyLoading ||
                  !(typeof inputPrompt === "string" ? inputPrompt : String(inputPrompt || "")).trim()
                }
                sx={{ minWidth: 160 }}
              >
                {t("juno.enhancement.translate")}
              </Button>
            )}

            <Button
              variant="contained"
              startIcon={enhanceLoading ? <CircularProgress size={16} color="inherit" /> : <AutoFixHighIcon />}
              onClick={onEnhance}
              disabled={
                isAnyLoading ||
                !(typeof inputPrompt === "string" ? inputPrompt : String(inputPrompt || "")).trim()
              }
              sx={{ minWidth: 160 }}
            >
              {t("juno.enhancement.enhance")}
            </Button>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default TextInputTab;